import { render, staticRenderFns } from "./UseLandscapeMode.vue?vue&type=template&id=8d451992&scoped=true"
import script from "./UseLandscapeMode.vue?vue&type=script&lang=js"
export * from "./UseLandscapeMode.vue?vue&type=script&lang=js"
import style0 from "./UseLandscapeMode.vue?vue&type=style&index=0&id=8d451992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d451992",
  null
  
)

export default component.exports